import React, { useState } from 'react';
import '../../styles/MesaVisual.css';

const MesaVisual = ({ mesa, onClick, onEdit, onDelete, isAdmin }) => {
  const [hovered, setHovered] = useState(false);

  const shapeStyle = {
    width: mesa.shape === 'circle' ? '60px' : '80px',
    height: '60px',
    borderRadius: mesa.shape === 'circle' ? '50%' : '10px',
    backgroundColor:
      mesa.status === 'libre' ? '#28a745' :
      mesa.status === 'ocupada' ? '#dc3545' :
      mesa.status === 'en_espera' ? '#ffc107' :
      mesa.status === 'abonada' ? '#17a2b8' :
      '#6c757d',
    left: `${mesa.pos_x}px`,
    top: `${mesa.pos_y}px`,
  };

  return (
    <div
      className="mesa-container"
      style={shapeStyle}
      onClick={() => onClick(mesa)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {mesa.name}
      {hovered && isAdmin && (
        <div className="mesa-btns" onClick={(e) => e.stopPropagation()}>
          <button className="mesa-btn" onClick={() => onEdit?.(mesa)}>✏️</button>
          <button className="mesa-btn" onClick={() => onDelete?.(mesa.id)}>❌</button>
        </div>
      )}
    </div>
  );
};

export default MesaVisual;
